



































import Vue from 'vue'
import CodesReservedList from '@/components/procodes/CodesReservedList.vue'
import { fetchReservedCodesList } from '@morpheus/procodes/admin-vue/services/procodes-client'
import { PoolShowData } from '@morpheus/procodes/admin-vue/types'

export default Vue.extend({
  name: 'CodesReserved',
  components: {
    CodesReservedList
  },
  data () {
    return {
      isLoading: true,
      poolsList: [] as Array<PoolShowData>
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchReservedCodesList('reserved')
        .then((pools: Array<PoolShowData>) => {
          pools.forEach(pool => {
            (pool.codes || []).forEach(code => {
              code.selected = false
            })
          })

          this.poolsList = pools
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.$store.commit('global/setLoading', false)
          this.isLoading = false
        })
    }
  }
})
